import { type SVGProps } from 'react';

interface UserBadgeIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const UserBadgeIcon = ({ size = 40, ...props }: UserBadgeIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.1314 17.4818C26.5903 17.469 31.455 23.4848 30.9662 29.8054C30.9404 30.4159 30.9629 31.2216 30.9662 31.9972C30.9694 32.7652 30.9549 33.5113 30.846 33.9742L30.8448 33.9793C30.769 34.2547 30.65 34.4687 30.5023 34.5966C30.3527 34.7257 30.1677 34.7669 29.9911 34.6809C29.8149 34.6349 29.7032 34.4631 29.6307 34.2873C29.5508 34.0935 29.4951 33.8419 29.4569 33.5755C29.3802 33.0402 29.3702 32.4117 29.3968 31.9857V31.9806C29.8549 27.6584 28.7845 24.4372 26.9661 22.2998C25.1467 20.1616 22.5691 19.0962 19.9921 19.101C17.4152 19.106 14.8404 20.1808 13.0258 22.3216C11.3256 24.3275 10.2847 27.2797 10.5466 31.1857L10.6168 31.9806V31.9818C10.6572 32.4118 10.6402 33.1675 10.5197 33.7685C10.4601 34.0655 10.3717 34.3447 10.2386 34.525C10.1707 34.6168 10.0826 34.6939 9.97147 34.7257C9.85728 34.7582 9.73962 34.7366 9.62513 34.6733L9.60852 34.6656L9.59574 34.6528C9.33951 34.4 9.19241 34.0615 9.11011 33.6879C9.02794 33.3144 9.00888 32.895 9.01298 32.4713C9.01711 32.0483 9.04434 31.6084 9.06154 31.201C9.0789 30.7896 9.0854 30.4076 9.04749 30.0853V30.0828C8.46605 23.645 13.2903 17.4821 19.8822 17.4818H20.1314ZM20.5429 2.51027L20.5493 2.51155C28.923 3.35292 28.484 15.5132 20.1225 15.8332H19.8886V15.832C17.6329 15.7222 15.9706 14.8092 14.8943 13.4996C13.8197 12.1923 13.3349 10.4982 13.4156 8.83628C13.4964 7.17456 14.1434 5.53697 15.3403 4.34162C16.4644 3.21905 18.0678 2.49347 20.125 2.50004L20.5429 2.51027ZM19.895 4.05407C13.0819 4.40558 13.4511 14.3963 20.2669 14.2485C21.8941 14.146 23.0946 13.4704 23.8849 12.5169C24.6769 11.5611 25.0622 10.3197 25.0414 9.08038C25.001 6.68019 23.4438 4.31591 20.4113 4.07196L20.1135 4.05535H19.895V4.05407Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </svg>
  );
};
